import {useDispatch, useSelector} from 'react-redux';
import {appActions, appSelectors} from '../slices';

export const useSideDrawer = () => {
  const dispatch = useDispatch();

  const isSideDrawerOpen = useSelector(appSelectors.getSideDrawerOpen);

  const onCloseSideDrawer = () => {
    dispatch(appActions.onSetSideDrawerOpen(false));
  };

  const onOpenSideDrawer = () => {
    dispatch(appActions.onSetSideDrawerOpen(true));
  };

  return {
    isSideDrawerOpen,
    onCloseSideDrawer,
    onOpenSideDrawer,
  };
};
